document.addEventListener('DOMContentLoaded', function() {
  var mainNavLinks = document.querySelectorAll('.main-nav__link');
  var menuHistory = [];

  mainNavLinks.forEach(function(navLink) {
    navLink.addEventListener('click', function(event) {
      if (window.innerWidth < 1087) {
        var childLinks = navLink.querySelector('.child-links');
        if (childLinks) {
          if (!childLinks.classList.contains('show')) {
            menuHistory.push(navLink);
            childLinks.style.display = 'block';
            requestAnimationFrame(() => {
              childLinks.classList.add('show');
            });
          }
        }
      }
    });
  });

  var subLinks = document.querySelectorAll('.sublinks');

  subLinks.forEach(function(subLink) {
    subLink.addEventListener('click', function(event) {
      event.stopPropagation();
      var subMenu = subLink.querySelector('.sublinks-menu');
      var childLinks = subLink.closest('.child-links');
      if (subMenu) {
        if (!subMenu.classList.contains('show')) {
          menuHistory.push(subLink);
          subMenu.style.display = 'block';
          requestAnimationFrame(() => {
            subMenu.classList.add('show');
            subMenu.classList.add('active');
          });
        } else {
          subMenu.classList.remove('show');
          subMenu.style.display = 'none';
          subMenu.classList.remove('active');
        }
      }
    });
  });

  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
        var subMenu = mutation.target;
        var childLinks = subMenu.closest('.child-links');

        if (subMenu.style.display === 'block' && childLinks) {
          var sublinksCount = subMenu.querySelectorAll('.sublinks-menu > li').length;

          if (sublinksCount < 8) {
            childLinks.classList.add('no-padding-bottom');
          } else {
            childLinks.classList.remove('no-padding-bottom');
          }
        } else {
          childLinks.classList.remove('no-padding-bottom');
        }
      }
    });
  });

  var subMenus = document.querySelectorAll('.sublinks-menu');
  subMenus.forEach(function(subMenu) {
    observer.observe(subMenu, {
      attributes: true,
      attributeFilter: ['style'], 
    });
  });

  document.body.addEventListener('click', function(event) {
    if (event.target.classList.contains('mobile-exit-navigation')) {
      if (menuHistory.length > 0) {
        var previousMenu = menuHistory.pop();
        var childLinks = previousMenu.querySelector('.child-links, .sublinks-menu');

        if (childLinks) {
          childLinks.style.display = 'none';
          childLinks.classList.remove('active');
          childLinks.classList.remove('no-padding-bottom'); 
        }
      }
    }
  });
});
